import React from 'react'

export default function SectionHeader (props) {
  return (
    <div className="section-header">
      <h2 className={props.headerColor}>{props.headerContent}</h2>
      <h4 className={props.subheaderColor}>{props.subheaderContent}</h4>
    </div>
  )
}



// WEBPACK FOOTER //
// ./components/SectionContent.js